import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Input, Icon, Tooltip } from '@fiverr-private/fit';
import { s_info_circle } from '@fiverr-private/icons';
import { BRAND_NAME_MAXLENGTH, SLOGAN_MAXLENGTH } from '../../../../../shared/constants';

import './style.scss';

const { POSITIONS } = Tooltip;

const ToolBar = ({
    brandName = translate('logo_maker_perseus.general.brand_name_placeholder'),
    brandNameError,
    slogan,
    onBrandNameChange,
    onSloganChange,
    inputProps,
}) => {
    const inputLabels = {
        brandName: translate('logo_maker_perseus.general.brand_name'),
        slogan: translate('logo_maker_perseus.general.slogan'),
    };

    return (
        <div className="listings-toolbar">
            <div className="form-wrapper">
                <label className={classnames({ 'has-error': !!brandNameError })}>
                    <span className="input-label">
                        {inputLabels.brandName}
                        <Tooltip
                            content={<I18n k="logo_maker_perseus.buyer.listing.help" />}
                            className="help-tooltip text-body-2"
                            boxClassName="help-tooltip-box"
                            appendToBody={false}
                            position={POSITIONS.RIGHT}
                        >
                            <Icon size={16}>{s_info_circle}</Icon>
                        </Tooltip>
                    </span>
                    <Input
                        name="brandName"
                        {...inputProps}
                        value={brandName}
                        onChange={({ target: { value } }) => onBrandNameChange(value, inputLabels.brandName)}
                        maxLength={BRAND_NAME_MAXLENGTH}
                    />
                    {brandNameError && <span className="error-message">{brandNameError}</span>}
                </label>
                <label>
                    <span className="input-label">{inputLabels.slogan}</span>
                    <Input
                        name="slogan"
                        {...inputProps}
                        value={slogan}
                        placeholder={translate('logo_maker_perseus.general.slogan_placeholder')}
                        onChange={({ target: { value } }) => onSloganChange(value, inputLabels.slogan)}
                        maxLength={SLOGAN_MAXLENGTH}
                    />
                </label>
            </div>
        </div>
    );
};

ToolBar.propTypes = {
    brandName: PropTypes.string,
    brandNameError: PropTypes.bool,
    slogan: PropTypes.string,
    onBrandNameChange: PropTypes.func.isRequired,
    onSloganChange: PropTypes.func,
    inputProps: PropTypes.object,
};

export default ToolBar;
